import React, { useEffect, useState } from 'react'
import { Typography } from 'antd'
import { IntlProvider } from 'react-intl'
import { NotificationPlatform } from '@vacationtracker/shared/types/notification-v2'
import { LocaleEnum } from '@vacationtracker/shared/types/i18n'
import { ILocaleEntry, getCachedLanguage, isLanguageLoaded, loadLanguage } from '@vacationtracker/shared/i18n/language-provider'
import logo from '../../assets/images/logo-revert-color.png'
import VTLogoPurple from '../../assets/images/VT-Logo-Purple.svg'

import { PiEnvelopeOpen, PiMicrosoftTeamsLogo, PiSlackLogo } from 'react-icons/pi'
import IntlMessages from '../../util/IntlMessages'
import isArray from 'lodash/isArray'

const { Text } = Typography

const BirthdayMessagePreview = ({
  platform,
  userName,
  time,
  channelName,
  addresses,
  previewLocale,
}: {
  platform: NotificationPlatform
  userName: string
  time?: string
  channelName?: string
  addresses?: string | string[]
  previewLocale?: LocaleEnum
}) => {
  const [localeEntry, setLocaleEntry] = useState<ILocaleEntry | undefined>(() => (previewLocale && isLanguageLoaded(previewLocale) ? getCachedLanguage(previewLocale) : undefined))

  useEffect(() => {
    if (!previewLocale) {
      setLocaleEntry(undefined)
      return
    }
    let isMounted = true
    loadLanguage(previewLocale).then((entry) => {
      if (isMounted) setLocaleEntry(entry)
    })
    return () => {
      isMounted = false
    }
  }, [previewLocale])

  const mention = platform === 'slack' ? `@${userName}` : userName
  let platformIcon = <PiEnvelopeOpen />
  let platformName = 'Email'
  if (platform === 'slack') {
    platformIcon = <PiSlackLogo />
    platformName = 'Slack'
  } else if (platform === 'microsoft') {
    platformIcon = <PiMicrosoftTeamsLogo />
    platformName = 'Microsoft Teams'
  }

  const content = (
    <div className="birthday-message-preview">
      <div className="birthday-message-preview-header">
        <span>{platformIcon}</span>
        {platformName}
      </div>
      {platform === 'email' ? (
        <>
          <div className="birthday-message-preview-body-email-top">
            <div className="birthday-message-preview-body-info">
              <div className="birthday-message-preview-body-info-form">
                <Text type="secondary">
                  <IntlMessages id="app.emailForm" />
                </Text>
              </div>
              <div className="birthday-message-preview-body-info-value">Vacation Tracker &lt;no-reply@vacationtracker.io&gt;</div>
            </div>
            <div className="birthday-message-preview-body-info">
              <div className="birthday-message-preview-body-info-form">
                <Text type="secondary">
                  <IntlMessages id="app.emailTo" />
                </Text>
              </div>
              <div className="birthday-message-preview-body-info-value">{isArray(addresses) ? addresses.join(', ') : ''}</div>
            </div>
            <div className="birthday-message-preview-body-info">
              <div className="birthday-message-preview-body-info-form">
                <Text type="secondary">
                  <IntlMessages id="app.emailSubject" />
                </Text>
              </div>
              <div className="birthday-message-preview-body-info-value">
                <IntlMessages id="components.birthdayMessagePreview.happyBirthday" />, <span>{mention}</span>!
              </div>
            </div>
          </div>
          <div className="birthday-message-preview-body-email-bottom">
            <div className="birthday-message-preview-body-email-bottom-logo">
              <VTLogoPurple style={{ height: '30px' }} />
            </div>
            <div className="birthday-message-preview-body-email-bottom-text">
              <div className="birthday-message-preview-body-email-bottom-text-emoji">🎂</div>
              <div className="birthday-message-preview-body-email-bottom-text-name">
                <IntlMessages id="components.birthdayMessagePreview.todayWeCelebrate" values={{ name: userName }} />
              </div>
              <div className="birthday-message-preview-body-email-bottom-text-description">
                <IntlMessages id="components.birthdayMessagePreview.happyBirthdayMessageEmailDescription" />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="birthday-message-preview-body">
          <div className="birthday-message-preview-avatar">
            <img src={logo} alt="logo" />
          </div>
          <div>
            <div className="birthday-message-preview-header-info">
              <span className="birthday-message-preview-header-info-text">Vacation Tracker</span>
              {platform === 'slack' && <span className="birthday-message-preview-header-info-app">APP</span>}
              <span style={{ color: '#888', fontSize: 11 }}>{time}</span>
            </div>
            <div className="birthday-message-preview-header-text">
              <strong>
                <IntlMessages id="components.birthdayMessagePreview.happyBirthday" />, <span>{mention}</span>!
              </strong>
            </div>
            <div className="birthday-message-preview-body-text">
              <IntlMessages id="components.birthdayMessagePreview.happyBirthdayMessage" />
            </div>
          </div>
        </div>
      )}
    </div>
  )

  if (!localeEntry) {
    return content
  }

  return (
    <IntlProvider locale={localeEntry.locale} messages={localeEntry.messages}>
      {content}
    </IntlProvider>
  )
}
export default BirthdayMessagePreview
